export default __webpack_public_path__ + "static/media/account.0eee6975.png";